import { lazy, Suspense, useRef } from "react";
import NewHeader from "@/components/NewHeader";
import Hero from "@/components/pages/node/Hero";
import WhatIsNode from "@/components/pages/node/WhatIsNode";
import WhyNode from "@/components/pages/node/WhyNode";
import Partners from "@/components/pages/node/Partners";
import About from "@/components/pages/node/About";
import Tokenomics from "@/components/pages/node/Tokenomics";
import Ecosystem from "@/components/pages/node/Ecosystem";
import Team from "@/components/pages/node/Team";
import FollowUs from "@/components/FollowUs";
import Feet from "@/components/Feet";

const WorkWithUs = lazy(() => import("@/components/WorkWithUs"));

export function Node() {
  const home = useRef(null);
  const expertises = useRef(null);
  const mission = useRef(null);
  const advantage = useRef(null);
  const team = useRef(null);

  return (
    <div className="flex flex-col justify-start relative items-center">
      <NewHeader reflist={[home, expertises, mission, advantage, team]} />
      <div className="max-w-[1200px]">
        <Hero />
        <WhatIsNode />
        <WhyNode />
        <Partners />
        <About />
        <Tokenomics />
        <Ecosystem />
        <Team />
        <FollowUs />
      </div>
      <Suspense fallback={null}>
        <WorkWithUs />
      </Suspense>
      <Feet />
    </div>
  );
}
